export default __webpack_public_path__ + "static/media/speakers__huda-idrees.950ccbf7.jpg";